import * as Sentry from '@sentry/react';

let initialized = false;

export const initSentry = () => {
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn || process.env.NODE_ENV !== 'production') return;

    Sentry.init({
        dsn,
        environment: 'production',
        tracesSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
        ],
    });
    initialized = true;
};

export const captureException = (error, context) => {
    if (!initialized) return;
    Sentry.captureException(error, context);
};
